import type { QuestionnaireState } from "../../types";

export const handleConfirmAssumptionGroupAction = (
  state: QuestionnaireState,
  payload: number, // assumption group index
): QuestionnaireState => {
  const { confirmedAssumptionGroups } = state;

  const updatedConfirmedAssumptionGroups = new Set(confirmedAssumptionGroups);
  updatedConfirmedAssumptionGroups.add(payload);

  return {
    ...state,
    confirmedAssumptionGroups: updatedConfirmedAssumptionGroups,
  };
};
